export default __webpack_public_path__ + "static/media/tools.8502147e.svg";